// extracted by mini-css-extract-plugin
export default {"menu":"PaymentAddEditor_menu__EZM8w","fieldAmount":"PaymentAddEditor_fieldAmount__cpc96","wrapper":"PaymentAddEditor_wrapper__eQzgt"};